export default "__VITE_ASSET__Dz2qys7O__"